import { createFileRoute } from '@tanstack/react-router'
import { StoreReadinessPage } from '@/pages/store-readiness'

export const Route = createFileRoute('/_authenticated/store-readiness')({
  staticData: { title: 'Store readiness' },
  component: StoreReadinessPage,
})
